<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row pt-3 new-row">
        <div class="pb-3 pl-4 pr-4">
          <div class="row align-items-center white-bg py-3">
            <div class="col-md-1 remove-right-padding col-center-flex">
              <div class="square-icon-wrapper small sky-bg">
                <img src="@/assets/img/bank-building (2).svg" width="35" />
              </div>
            </div>
            <div class="col-md-7">
              <h4 class="primary-color font-600">
                {{ $t("text.bankAccounts.bankTransBreakdown") }}
              </h4>
              <!-- <p class="light-grey-text mt-3">View your live bank account transactions here...</p> -->
            </div>
            <div class="col-md-3 flexify">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :custom-shortcuts="customShortcuts"
                color="#4b2d73"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.sendReport.dateRange')"
              />
              <!-- <input type="text" placeholder="search..." class="mt-1 ml-5" v-model="searchTerm" /> -->
            </div>
          </div>
        </div>
        <div class="">
          <div class="invoice-banner">
            <div>
              <div>
                <h6 class="font-600 primary-color">
                  {{ $t("text.bankAccounts.totalCredit") }}
                </h6>
              </div>
              <div class="mt-2">
                <span
                  ><span class="currency"></span
                  ><span class="amount-figures primary-color"
                    >{{ region ? region.currencyCode : "" }}
                    {{ convertThousand(totalCredit) }}</span
                  ><span class="bold-span primary-color"></span
                ></span>
              </div>
              <div class="mt-2"></div>
            </div>
            <div>
              <div>
                <h6 class="font-600 primary-color">
                  {{ $t("text.bankAccounts.totalDebit") }}
                </h6>
              </div>
              <div class="mt-2">
                <span
                  ><span class="currency"></span
                  ><span class="amount-figures primary-color"
                    >{{ region ? region.currencyCode : "" }}
                    {{ convertThousand(totalDebit) }}</span
                  ><span class="bold-span primary-color"></span
                ></span>
              </div>
            </div>
            <div>
              <div>
                <h6 class="font-600 primary-color">
                  {{ $t("text.bankAccounts.balance") }}
                </h6>
              </div>
              <div class="mt-2">
                <span
                  ><span class="currency"></span
                  ><span class="amount-figures primary-color"
                    >{{ region ? region.currencyCode : "" }}
                    {{ convertThousand(balance) }}</span
                  ><span class="bold-span primary-color"></span
                ></span>
              </div>
              <div class="mt-2"></div>
            </div>
          </div>
        </div>
        <div class="new-row mt-3">
          <div class="row">
            <div class="col-md-8"></div>
            <div class="col-md-4">
              <div class="d-flex align-items-center justify-content-end">
                <div
                  class="mr-3 cursor-pointer"
                  v-if="prev"
                  v-b-tooltip
                  title="Previous"
                  @click="prevPage"
                >
                  <i
                    class="fa fa-angle-double-left pagination-arrow"
                    aria-hidden="true"
                  ></i>
                </div>
                <div
                  class="mr-3 page-number d-flex align-items-center justify-content-center"
                  v-b-tooltip
                  title="Current page"
                >
                  {{ page }}
                </div>
                <div
                  class="cursor-pointer"
                  v-b-tooltip
                  title="Next"
                  @click="nextPage"
                >
                  <i
                    class="fa fa-angle-double-right pagination-arrow"
                    aria-hidden="true"
                    v-if="next"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative mt-3">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :allowSorting="false"
            :allowExcelExport="false"
            :allowPdfExport="false"
            :toolbarClick="toolbarClick"
            :toolbar="toolbar"
            :allowTextWrap="true"
            :rowDataBound="rowDataBound"
            :searchSettings="search"
            :locale="usedLang"
          >
            <e-columns>
              <e-column
                width="200"
                field="date"
                :format="formatOptions"
                type="date"
                :headerText="$t('text.bankAccounts.date')"
              ></e-column>
              <e-column field="narration" headerText="Narration"></e-column>
              <e-column
                width="100"
                field="type"
                :headerText="$t('text.bankAccounts.type')"
              ></e-column>
              <e-column
                width="200"
                field="amountInNaira"
                :headerText="$t('text.bankAccounts.amount')"
                format="N2"
                textAlign="right"
              ></e-column>
              <e-column
                width="200"
                field="balance"
                :headerText="$t('text.bankAccounts.bal')"
                format="N2"
                textAlign="right"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <div class="mt-3" style="margin: 0 auto">
            <!-- <Paginator 
                            v-show="!showLoader"
                            :total-pages="totalPages"
                            :per-page="pageSize"
                            :current-page="currentPage"
                            @pagechanged="onPageChange"
                            @getPageSize="getPageSize"
                            :pageSize="pageSize"
                        /> -->
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/RegionalManager/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import { Page, Sort, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import invoiceTemp from "@/components/Templates/list_of_invoices_template.vue";
import VueMomentsAgo from "vue-moments-ago";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Bank transactions:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    VueMomentsAgo,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      regionId: null,
      isButtonDisabled: false,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },

      region: null,
      totalAmount: 0,
      liveBankTransactionsDetails: null,
      totalCredit: 0,
      totalDebit: 0,
      balance: 0,
      bankId: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      fmId: null,
      next: null,
      page: 1,
      prev: null,
    };
  },
  watch: {
    region(region) {
      if (region !== null) {
        this.getTransaction();
      }
    },
    page() {
      this.getTransaction();
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.totalCredit = 0;
        this.totalDebit = 0;
        this.balance = 0;
        this.getTransaction();
      }
    },
  },
  created() {
    this.$eventHub.$on("region", (region) => {
      this.region = region;
    });
    if (this.$route.query.regionId) {
      this.getTransaction();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });

    const searchFun = (event) => {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      this.searchValue = value;
      grid.search(value);
    };
  },
  methods: {
    nextPage() {
      this.page = this.page + 1;
    },
    prevPage() {
      this.page = this.page - 1;
    },
    getTransaction() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/SingleBankLiveTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.region.companyId
          }/${this.$route.query.bankId}?page=${this.page}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.liveBankTransactionsDetails = response.data[0];
          this.page = this.liveBankTransactionsDetails.page;
          this.prev = this.liveBankTransactionsDetails.prev;
          this.next = this.liveBankTransactionsDetails.next;
          this.totalCredit = this.liveBankTransactionsDetails.credit;
          this.totalDebit = this.liveBankTransactionsDetails.debit;
          this.liveBankTransactionsDetails.transactions.forEach((el, index) => {
            el.index = index + 1;
            el.amount = el.amount;
            el.balance = el.balance;
          });

          this.balance = this.liveBankTransactionsDetails.balance;

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: this.liveBankTransactionsDetails.transactions,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    rowDataBound: function (args) {
      if (args.data["type"] === "credit") {
        args.row.cells[2].style.color = "green";
      } else {
        args.row.cells[2].style.color = "red";
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "branches.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>
